import React from 'react'

const About = () => {
    return (
        <div className='container mt-5 text-center'>
            About Page
        </div>
    )
}

export default About
